export const dialog = theme => ({
  [theme.breakpoints.down('lg')]: {
    margin: theme.spacing(0, 2),
    minHeight: 500,
    minWidth: 325,
  },
  minHeight: 475,
  minWidth: 500,
});

export const dialogContent = theme => ({
  [theme.breakpoints.down('lg')]: {
    padding: theme.spacing(0, 2, 2, 0),
  },
});

export const dialogTitle = theme => ({
  padding: theme.spacing(3, 3, 0),
});

export const parentScroll = theme => ({
  display: 'flex',
  overflow: 'auto',
  padding: theme.spacing(2, 3, 3),
  scrollSnapType: 'x mandatory',
  [theme.breakpoints.down('lg')]: {
    overflowY: 'auto',
    padding: theme.spacing(0, 3, 3),
  },
  [theme.breakpoints.up(1464)]: {
    justifyContent: 'center',
  },
});

export const scroll = theme => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  [theme.breakpoints.down('lg')]: {
    marginBottom: theme.spacing(8),
    overflowY: 'auto',
  },
});

export const scrollContainer = (theme, subscriptionTierDetailsLoading) => ({
  alignItems: 'flex-start',
  display: 'inline-flex',
  gridGap: theme.spacing(3),
  overflowX: subscriptionTierDetailsLoading ? 'hidden' : 'visible',
});
